import SourcesDetails from './SourcesDetails';

export default SourcesDetails;
